import InsightsRoute from "@/vnext/routes/insights/InsightsRoute";

export default function IntegrationsRoute() {
  return <InsightsRoute initialTab="integrations" mode="settings" />;
}
